import { useStore } from '@betgames/bg-state-manager';
import { IPLSGameId, gameBlackjackSelectors, gameBlackjackStore, t } from '@bg-shared';
import classes from './ActiveBJSeats.module.scss';

interface IProps {
    gameId: IPLSGameId;
}

export const ActiveBJSeats = (props: IProps) => {
    const activeSeats = useStore(
        gameBlackjackStore,
        gameBlackjackSelectors.getAvailableSeats(props.gameId),
    );

    return (
        <div className={classes.structure}>
            <span className={classes.count}>{activeSeats}</span>
            {t.string('seats_available')}
        </div>
    );
};
